<div class="cv-photo-review-container" *ngIf="uiState === photoReviewUiState.HAS_PHOTOS">
	<div
		*ngIf="selectedSchema === schemaType.INSPECTION_R"
		class="cv-photo-review-container__tabs"
		[ngStyle]="{ width: detailContentVisble ? '75%' : '100%' }"
	>
		<div *ngIf="hasStructures" class="cv-photo-review-container__structure">
			<div
				#strucuturesBtn
				*ngFor="let structure of structureOptions; let i = index"
				(click)="structurePhotos(structure, i)"
				class="cv-photo-review-container__structure__btn"
			>
				<span>{{ structure }}</span>
			</div>
			<hr />
		</div>
		<cv-tab-group [setActive]="activeTab" (getCurrentTab)="getActiveTab($event)">
			<cv-tab [title]="photoReviewUiState.TAB_TITLES.ALL" [active]="true">
				<div class="cv-photo-review-container__navigation">
					<div class="mb-4">
						<cv-form-group-navigation
							[form]="orderWithPhotos"
							[formArrayKeysToFlat]="photoReviewNavigationService.arraysToFlat"
							[formArrayKeysExclusions]="photoReviewNavigationService.arraysToExclude"
							[nameCallback]="photoReviewNavigationService.nameCallback"
							[clearOnElementSelected]="true"
							(elementSelected)="navigationElementSelected($event)"
						>
						</cv-form-group-navigation>
					</div>
				</div>
				<a
					href="javascript:void(0)"
					*ngIf="selectedRuleMessage"
					class="cv-photo-review-container__tabs__clear-result"
					(click)="clearRuleSelection()"
					><i class="far fa-times-circle"></i> Clear rule Selection
				</a>
				<div class="cv-photo-review-container__tabs-content" #photocontainer>
					<cv-photo-card
						*ngIf="isSorted"
						class="cv-photo-review-container__card-component"
						[photos]="sortingCard"
						[ruleType]="selectedRuleMessage"
						[cardType]="photoReviewUiState.TAB_TITLES.ALL"
						[isSorted]="isSorted"
						[removedSelection]="removedSelection"
						(getPhotoCardContent)="getPhotoInfo($event)"
						[SchemaType]="selectedSchema"
					></cv-photo-card>

					<cv-photo-card
						class="cv-photo-review-container__card-component"
						[photos]="photos"
						[SchemaType]="selectedSchema"
						[removedSelection]="removedSelection"
						(getPhotoCardContent)="getPhotoInfo($event)"
						[cardType]="photoReviewUiState.TAB_TITLES.ALL"
					></cv-photo-card>
				</div>
			</cv-tab>
			<cv-tab [title]="photoReviewUiState.TAB_TITLES.SKETCH">
				<div
					[ngClass]="{
						'cv-photo-review-container__tabs-content-base': !hasStructures,
						'cv-photo-review-container__tabs-content': hasStructures
					}"
				>
					<cv-photo-card
						class="cv-photo-review-container__card-component"
						[photos]="photosSketch"
						[SchemaType]="selectedSchema"
						[cardType]="photoReviewUiState.TAB_TITLES.SKETCH"
					></cv-photo-card>
				</div>
			</cv-tab>
			<cv-tab
				[title]="photoReviewUiState.TAB_TITLES.PROPERTY_CARD"
				*ngIf="photosPropertyCard?.length"
			>
				<div
					[ngClass]="{
						'cv-photo-review-container__tabs-content-base': !hasStructures,
						'cv-photo-review-container__tabs-content': hasStructures
					}"
				>
					<cv-photo-card
						class="cv-photo-review-container__card-component"
						[photos]="photosPropertyCard"
						[SchemaType]="selectedSchema"
						[cardType]="photoReviewUiState.TAB_TITLES.SKETCH"
					></cv-photo-card>
				</div>
			</cv-tab>
			<cv-tab [title]="photoReviewUiState.TAB_TITLES.EXTERIOR">
				<div
					[ngClass]="{
						'cv-photo-review-container__tabs-content-base': !hasStructures,
						'cv-photo-review-container__tabs-content': hasStructures
					}"
				>
					<cv-photo-card
						class="cv-photo-review-container__card-component"
						[photos]="photosExterior"
						[SchemaType]="selectedSchema"
						[cardType]="photoReviewUiState.TAB_TITLES.EXTERIOR"
					></cv-photo-card>
				</div>
			</cv-tab>
			<cv-tab [title]="photoReviewUiState.TAB_TITLES.INTERIOR">
				<div
					[ngClass]="{
						'cv-photo-review-container__tabs-content-base': !hasStructures,
						'cv-photo-review-container__tabs-content': hasStructures
					}"
				>
					<cv-photo-card
						class="cv-photo-review-container__card-component"
						(getPhotoCardContent)="getPhotoInfo($event)"
						[photos]="photosInterior"
						[SchemaType]="selectedSchema"
						[cardType]="photoReviewUiState.TAB_TITLES.INTERIOR"
					></cv-photo-card>
				</div>
			</cv-tab>
		</cv-tab-group>
	</div>
	<div class="cv-photo-review-container__photo-detail" *ngIf="detailContentVisble">
		<div class="cv-photo-review-container__photo-detail-title">Photo {{ contentType }} Info</div>
		<cv-photo-content-detail [info]="contentInfo" [type]="contentType"></cv-photo-content-detail>
	</div>
	<div
		*ngIf="selectedSchema !== schemaType.INSPECTION_R"
		class="cv-photo-review-container__CVReview"
	>
		<cv-photo-card
			class="cv-photo-review-container__card-component"
			[photos]="photos"
			[cardType]="photoReviewUiState.TAB_TITLES.ALL"
			[SchemaType]="selectedSchema"
		></cv-photo-card>
	</div>
</div>
<div *ngIf="uiState === photoReviewUiState.NO_PHOTOS" class="cv-photo-unavailable text-center">
	No Photos to display
</div>
<div class="cv-photo-loading-container" *ngIf="uiState === photoReviewUiState.IS_LOADING">
	<div class="cv-photo-loading-container__spinner"></div>
</div>
